import { FC } from 'react'
import styled from 'styled-components'
import FilterField from '../../../components/FilterFieldWrapper'
import { useKeywordField } from './KeywordField.module'
import KeywordInput from './KeywordInput'

interface IFKeywordFieldProps {
  className?: string
}

const KeywordField: FC<IFKeywordFieldProps> = ({ className }) => {
  const { keyword, onKeywordChange, onKeywordReset } = useKeywordField()

  return (
    <StyledWrapper label="키워드 검색" className={className}>
      <KeywordInput
        value={keyword}
        onChange={onKeywordChange}
        onReset={onKeywordReset}
      />
    </StyledWrapper>
  )
}

export default KeywordField

const StyledWrapper = styled(FilterField)``
